import { catchError, map } from 'rxjs/operators';
import { EventEmitter, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class HttpService {
  [x: string]: any;
  oAuthHeader = 'Basic ' + btoa('sJ6fOavXhdMcaMThECVK:gMV4U2mDa4sHp9u1B324bmrUPvQXfXSFz4cn9Z61UeQ9QuJRHa');
  baseApiUrl: string;
  baseApiPath = '/api/v1';
  constructor(private http: HttpClient) {
    if (environment.production) {
      this.baseApiUrl = '';
    } else {
      this.baseApiUrl = 'https://cal360.calbd.com.bd'; // live
      //this.baseApiUrl = 'https://cal360uat.calbd.com.bd';
      // this.baseApiUrl = 'https://portaluat.cal.lk';
      // this.baseApiUrl = 'http://13.94.37.71:8080';
    }
  }
  getDownloadUrl(path, data = {}) {
    let url = this.baseApiUrl + this.baseApiPath + path;
    const token = localStorage['atk'];
    data['token'] = token;
    if (data) {
      url += '?' + $.param(data);
    }
    return url;
  }

  get(url: string, data?: any) {
    const token = localStorage['atk'];
    // console.log(token, 78);
    let headers;
    // this.appendBearerToken(headers);
    if (token) {
      headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token).set('Content-Type', 'application/json');
    } else {
      headers = new HttpHeaders();
    }
    let formatedUrl = this.baseApiUrl + this.baseApiPath + url;
    if (data) {
      Object.keys(data).forEach((k) => {
        if (data[k] === undefined) {
          delete data[k];
        }
      });
      formatedUrl += '?' + $.param(data);
    }
    return this.http
      .get(formatedUrl, { headers })
      .pipe(
        map((res) => {
          // console.log(res);
          // console.log(JSON.parse(JSON.stringify(res)));
          return JSON.parse(JSON.stringify(res));
        }),
        catchError((e) => this.catchErrors(e, url))
      )
      .toPromise();
  }
  post(url: string, data: any = {}, options: any = {}) {
    const token = localStorage['atk'];
    let headers;
    if (token) {
      headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);
    } else {
      headers = new HttpHeaders();
    }
    // this.appendBearerToken(headers);
    let apiPath = this.baseApiPath;
    if (options.apiPath !== undefined) {
      apiPath = '';
    }
    let formatedUrl = this.baseApiUrl + apiPath + url;
    return this.http
      .post(formatedUrl, data, { headers })
      .pipe(
        map((res) => JSON.parse(JSON.stringify(res))),
        catchError((e) => {
          return this.catchErrors(e, url);
        })
      )
      .toPromise()
      .catch((e) => {
        return this.catchErrors(e, formatedUrl);
      });
  }
  put(url: string, data?: any) {
    const token = localStorage['atk'];
    const headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);
    // this.appendBearerToken(headers);
    let formatedUrl = this.baseApiUrl + this.baseApiPath + url;
    return this.http
      .put(formatedUrl, data, { headers })
      .pipe(
        map((res) => JSON.parse(JSON.stringify(res))),
        catchError((e) => {
          return this.catchErrors(e, url);
        })
      )
      .toPromise()
      .catch((e) => {
        return this.catchErrors(e, url);
      });
  }
  delete(url: string) {
    const token = localStorage['atk'];
    const headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);
    // this.appendBearerToken(headers);
    url = this.baseApiUrl + this.baseApiPath + url;
    return this.http.delete(url, { headers }).toPromise();
  }
  postForm(url: string, data: any, options: any = {}) {
    const token = localStorage['atk'];
    let headers;
    headers = new HttpHeaders()
      .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
      .set('Access-Control-Allow-Content-Type', 'application/x-www-form-urlencoded')
      .set('Access-Control-Allow-Credentials', 'true')
      .set('Access-Control-Allow-Origin', '*');
    if (!options.oAuthHeader) {
      if (token) {
        headers = new HttpHeaders()
          .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
          .set('Access-Control-Allow-Content-Type', 'application/x-www-form-urlencoded')
          .set('Access-Control-Allow-Credentials', 'true')
          .set('Authorization', token && 'Bearer ' + token);
      }
    } else {
      headers = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded;charset=UTF-8')
        .set('Access-Control-Allow-Content-Type', 'application/x-www-form-urlencoded')
        .set('Access-Control-Allow-Credentials', 'true')
        .set('Authorization', options.oAuthHeader && options.oAuthHeader);
    }

    // if (options.contentType !== undefined) {
    //   headers.append('Content-Type', options.contentType);
    //   headers.append('Access-Control-Allow-Content-Type', options.contentType);
    // } else {
    //   headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //   headers.append('Access-Control-Allow-Content-Type', 'application/x-www-form-urlencoded');
    // }
    // this.appendBearerToken(headers, options.oAuthHeader);
    let apiPath = this.baseApiPath;
    if (options.apiPath !== undefined) {
      apiPath = '';
    }
    let formatedUrl = this.baseApiUrl + apiPath + url;
    const corrected = JSON.stringify(data).replace(/(&amp;)/gm, '&');
    // Convert back to JSON object.
    const corrected2 = JSON.parse(corrected);
    // entries() iterates form key:value pairs, URLSearchParams() is for query strings
    const URLparams = new URLSearchParams(corrected2);
    return this.http
      .post(formatedUrl, URLparams.toString(), { headers })
      .pipe(
        map((res) => JSON.parse(JSON.stringify(res))),
        catchError((e) => {
          return this.catchErrors(e, url);
        })
      )
      .toPromise()
      .catch((e) => {
        return this.catchErrors(e, url);
      });
  }
  unthorisedWithTokenPost(url: string, data: any = {}, options: any = {}): Promise<any> {
    // Custom Authorization header (could be dynamic based on use-case)
    const auth = 'x%Aw_yCnlAp@7C5Gsj4j';
    let headers = new HttpHeaders().set('Authorization', auth).set('Content-Type', 'application/json');

    // Determine API path
    const apiPath = options.apiPath !== undefined ? '' : this.baseApiPath;
    const formatedUrl = this.baseApiUrl + apiPath + url;

    // Make HTTP POST request
    return this.http
      .post(formatedUrl, data, { headers, responseType: 'text' })
      .pipe(
        map((res) => {
          return res; // Return the actual response
        }),
        catchError((e) => {
          console.error('Request failed:', e);
          return this.catchErrors(e, url); // Pass errors to custom error handler
        })
      )
      .toPromise();
  }
  appendBearerToken(headers, oAuthHeader?) {
    const token = localStorage['atk'];

    if (!oAuthHeader) {
      if (token) {
        headers.append('Authorization', 'Bearer ' + token);
      }
    } else {
      headers.append('Authorization', oAuthHeader);
    }
  }
  catchErrors(errorRes: Response, url) {
    let excludeUrls = [
      '/reset-password',
      '/request-reset-password',
      '/signup',
      '/verify-signup-code',
      '/captcha',
      '/send-password-reset',
      '/send-signup-verification-codes',
      '/verify-signup-code',
      '/financial/equity-portfolio',
      '/margin-trade/portfolio',
      '/products/get-base64-stream',
    ];
    // if (errorRes.status === 0) {
    //   if (window.location.pathname.indexOf('/login') < 0) {
    //     window.location.href = '/login';
    //   }
    // }
    console.log(errorRes.status);
    if (errorRes.status === 502 || errorRes.status === 0) {
      if (window.location.pathname.indexOf('/maintenance') < 0) {
        window.location.href = '/maintenance';
      }
    } else if (errorRes.status === 401 || errorRes.status === 403 || errorRes.status === 504) {
      console.log(url, errorRes);
      if (excludeUrls.every((excludePath) => url.includes('/me/financial') || url.indexOf(excludePath) < 0)) {
        window.location.href = '/';
      }
      if (url.indexOf('live-market-data') >= 0) {
        localStorage.clear();
      }
    }
    return Promise.reject(errorRes);
  }
}

export class HttpResource {
  static onUpdated = new EventEmitter();
  static onInserted = new EventEmitter();
  static onDeleted = new EventEmitter();
  private static customEvents = {};
  static Insert(target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
    httpResourceUpdateInterceptFactory(HttpResource.onInserted, descriptor);
  }
  static Update(target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
    httpResourceUpdateInterceptFactory(HttpResource.onUpdated, descriptor);
  }
  static Delete(target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
    httpResourceUpdateInterceptFactory(HttpResource.onDeleted, descriptor);
  }
  static On(eventName) {
    let event = HttpResource.customEvents[eventName];
    if (!event) {
      event = HttpResource.customEvents[eventName] = new EventEmitter();
    }
    return function (target: Object, propertyKey: string, descriptor: TypedPropertyDescriptor<any>) {
      httpResourceUpdateInterceptFactory(event, descriptor);
    };
  }
  onEvent(eventName) {
    return HttpResource.customEvents[eventName];
  }
}

function httpResourceUpdateInterceptFactory(eventEmitter: EventEmitter<any>, descriptor: TypedPropertyDescriptor<any>) {
  const originalMethod = descriptor.value;
  descriptor.value = function () {
    const promise = originalMethod.apply(this, arguments);
    if (promise instanceof Promise) {
      return promise.then((res) => {
        if (res) {
          eventEmitter.emit(res.data);
        }

        return res;
      });
    }
    return promise;
  };
}

export class ListQuery {
  public total = 0;
  useSkipTake = false;
  private _skip = 0;
  private _take = 10;
  sort: any[];

  get take() {
    return this._take;
  }
  set take(val) {
    this._take = val;
  }

  get skip() {
    return this._skip;
  }
  set skip(val) {
    this._skip = val;
  }

  get params() {
    let params = <any>{
      size: this._take,
      page: this._skip / this._take,
    };
    if (this.useSkipTake) {
      params = {
        skip: this._skip,
        take: this._take,
      };
    }
    if (!!this.filterFields) {
      // remove null fields
      const filters = {};
      Object.keys(this.filterFields).forEach((key) => {
        const filterVal = this.filterFields[key];
        if (filterVal !== null && filterVal !== '') {
          filters[key] = filterVal;
        }
      });
      params = Object.assign(filters, params);
    }
    if (!!this.sort && this.sort[0] && this.sort[0].field && this.sort[0].field.indexOf('.') < 0) {
      params['sort'] = `${this.sort[0].field},${this.sort[0].dir.toUpperCase()}`;
    }
    return params;
  }

  constructor(pageSize, public filterFields: { [key: string]: any } = {}, sortFields: { [key: string]: any } = {}) {
    this.take = pageSize;
  }

  setFilterField(param, val) {
    if (!param) {
      return;
    }
    this.filterFields[param] = val;
    return this;
  }

  next() {
    this.skip += this.take;
  }

  hasMore() {
    return this.total > this.skip;
  }
}
export class FindQuery {
  filterFields?: any;
  sortFields?: [string, string][];
  take?: number;
  skip?: number;
  page: number;
  size: number;
  sort: string;
  resultCount?: number;
  constructor({ filterFields = {}, sortFields = [], skip = 0, take = 10 }: any) {
    this.filterFields = filterFields;
    this.sortFields = sortFields;
    this.skip = skip;
    this.take = take;
  }
  build() {
    this.sort = 'createdTime,desc';
    if (this.sortFields && this.sortFields[0]) {
      this.sort = `${this.sortFields[0][0]},${this.sortFields[0][1]}`;
    }
    let params = {
      page: this.skip / this.take,
      size: this.take,
      sort: this.sort,
    };
    params = Object.assign(this.filterFields, params);
    return params;
  }
  addOrUpdateFilterFields(param: any) {
    if (!param) {
      return;
    }
    let fieldName = param[0],
      value = param[1];
    if (!this.filterFields) {
      this.filterFields = {};
    }
    this.filterFields[fieldName] = value;
  }
}
